import useSWR, { SWRResponse } from "swr";
import commonSwrConfig from "@portal/hooks/commonSwrConfig";
import { commonFetcher } from "../common/commonFetcher";
import { IUseUsesNorneFunds } from "./types";

const useUsesNorneFunds: IUseUsesNorneFunds = (centerId?: string) => {
  const { data, error, isLoading }: SWRResponse<boolean, unknown> = useSWR(
    centerId !== undefined ? `/api/robot/bank-uses-norne-funds/${centerId}` : null,
    commonFetcher<boolean>,
    commonSwrConfig(),
  );
  const response = { data, error, isLoading };

  return response;
};

export default useUsesNorneFunds;
